globalThis.SearchFilter = (function()
{
  var defaults = {
    removeSearch: false,
    minimumCharacters: 1,
    typingCallback: function() {},
    noResultsCallback: function() {}
  }

  function SearchFilter($html, options) {
    if($html.length === 1) {
      this.config            = $.extend({}, defaults, options);
      this.$html             = $html;
      this.classTarget       = this.$html.data('filter-target');
      this.classContainer    = this.$html.data('container');
      this.removeAccent      = this.$html.data('noaccent');
      this.$objects          = this.setObjects();
      this.noResultsTimeout  = null;
    }
  }

  SearchFilter.initFilters = function($html, options) {
    $.each($html, function() {
      var filter = new SearchFilter($(this), options);
      filter.init();
    });
  }

  SearchFilter.prototype =
  {
    // Private
    init : function(){
      var me = this;
      me.$html.keyup(function() {
        var search = $.trim($(this).val());

        clearTimeout(me.noResultsTimeout);

        if(me.config.removeSearch) {
          if(search != '') {
            me.$html.parent().addClass('has-search');
          } else {
            me.$html.parent().removeClass('has-search');
          }
        }

        (search.length >= me.config.minimumCharacters) ? me.render(search) : me.clear();

        me.config.typingCallback.call(me, search);

        me.noResultsTimeout = setTimeout(function() {
          if(search != '' && !me.resultsFound) me.config.noResultsCallback.call(me, search);
        }, 1500);
      });

      if(me.config.removeSearch) {
        $('body').on('click', 'span.remove-search', function() {
          $(this).closest('.search-filter').find('.filter').val('').trigger('keyup').focus();
        });
      }
    },
    setObjects : function(){
      if(this.classContainer != ''){
        return $(this.classContainer).find(this.classTarget);
      } else {
        return $(this.classTarget);
      }
    },
    render : function(textInput) {
      var me        = this,
          textInput = me.removeAccent ? _noAccent(textInput) : textInput;

      this.resultsFound = false;

      $.each(me.$objects, function(){
        var $this       = $(this),
            contentText = $.trim($this.data('content') || $this.text()),
            regex       = new RegExp(textInput, 'i');

        if(me.removeAccent) contentText = _noAccent(contentText);

        if(contentText.match(regex)) {
          if(!me.resultsFound) me.resultsFound = true;

          $this.show();
        } else {
          $this.hide();
        }
      });
    },
    clear : function(){
      this.resultsFound = true;

      this.$objects.show();
    }
  }

  function _noAccent(s) {
    var r = s.toLowerCase();
    r = r.replace(new RegExp(/[àáâãäå]/g),"a");
    r = r.replace(new RegExp(/æ/g),"ae");
    r = r.replace(new RegExp(/ç/g),"c");
    r = r.replace(new RegExp(/[èéêë]/g),"e");
    r = r.replace(new RegExp(/[ìíîï]/g),"i");
    r = r.replace(new RegExp(/ñ/g),"n");
    r = r.replace(new RegExp(/[òóôõö]/g),"o");
    r = r.replace(new RegExp(/œ/g),"oe");
    r = r.replace(new RegExp(/[ùúûü]/g),"u");
    r = r.replace(new RegExp(/[ýÿ]/g),"y");
    return r;
  }

  return SearchFilter;
})();
